import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./learn.html";
import Icon from '@oneappexchange/appx-design-system/modules/ax/icon/icon';
import { WireStore } from '@oneappexchange/lwc-wired';
import { WORDPRESS_SERVICE_URL } from '~/modules/config';
import { htmlDecode, loadWordPressScript } from '~/modules/helpers/wordPressHelper';
import { initialPageRenderedMetricsCheck } from '~/modules/services/metricsService';
import { routerStore } from '~/modules/stores/routerStore';
import { selectCurrentContentItem, wordPressStore } from '~/modules/stores/wordpress_store';

// @ts-expect-error * Automated Type Error Fix
Icon.defaultSpriteUrl = undefined;
import '../../../mfes/cmsElements';
import '../../../mfes/cmsElementsDynamic';
class Learn extends LightningElement {
  constructor(...args) {
    super(...args);
    this.firstRendered = false;
    this.isLoading = true;
    this.isError = false;
  }
  routeChange(state) {
    if (state.data) {
      // @ts-expect-error * Automated Type Error Fix
      wordPressStore.updateSlug(state.data.contentType, state.data.slug);
      // In the case of cached data, we should try to immediately update html
      this.updateCmsContent();
    }
  }
  cmsContentUpdated(state) {
    // This handles the case of data being fetched by client side navigation. The fetch will be triggered by
    // the above routeChange.
    this.updateCmsContent(state);
  }

  // @ts-expect-error * Automated Type Error Fix
  updateCmsContent(state = undefined) {
    const cmsState = state ?? wordPressStore.getState();
    const currentContent = selectCurrentContentItem(cmsState);
    if (currentContent) {
      this.isError = currentContent.isError;
      this.isLoading = currentContent.isLoading;
      const container = this.template.querySelector('div');
      if (container) {
        if (!currentContent.isError && !currentContent.isLoading) {
          const stylesheet = document.createElement('link');
          stylesheet.setAttribute('rel', 'stylesheet');
          stylesheet.setAttribute('href', `${WORDPRESS_SERVICE_URL}/wp-content/themes/appexchange/dist/css/frontend.css`);

          // eslint-disable-next-line @lwc/lwc/no-inner-html
          // @ts-expect-error * Automated Type Error Fix
          container.innerHTML = htmlDecode(currentContent.data.content.rendered);
          container.appendChild(stylesheet);
        } else {
          // eslint-disable-next-line @lwc/lwc/no-inner-html
          container.innerHTML = '';
        }
      }
    }
  }
  connectedCallback() {
    loadWordPressScript();
  }
  renderedCallback() {
    // This handles the case of data already being available via server side fetch
    if (!this.firstRendered) {
      this.updateCmsContent();
      initialPageRenderedMetricsCheck();
      this.firstRendered = true;
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Learn, {
  wire: {
    routeChange: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: routerStore
        };
      }
    },
    cmsContentUpdated: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: wordPressStore
        };
      }
    }
  },
  fields: ["firstRendered", "isLoading", "isError"]
});
const __lwc_component_class_internal = _registerComponent(Learn, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;